import React from 'react'
import Aboutus from '../../components/Navbar/About/Aboutus'

function AboutusPage() {
  return (
    <Aboutus/>
  )
}

export default AboutusPage